module.exports = __webpack_public_path__ + "img/nature7.ee3c6cf1.jpg";